/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var CampgroundIcon = createIcon({
  name: 'CampgroundIcon',
  height: 512,
  width: 640,
  svgPath: 'M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default CampgroundIcon;